// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1NGsM","content":"Consent_content__3U0ve","footer":"Consent_footer__1vBMS"};